import {
  GETCURRENTUSERDETAIL_FAIL,
  GETCURRENTUSERDETAIL_SUCCESS,
  SETCURRENTUSERDETAILS,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GETCURRENTUSERDETAIL_SUCCESS:
      return {
        ...state,
        ...payload
      };
    case GETCURRENTUSERDETAIL_FAIL:
      return {
        ...state
      };
    case SETCURRENTUSERDETAILS:
      return {
        ...state,
        user: payload,
      };
    default:
      return state;
  }
}
